import Utils from "./Utils";
export default class DOMConfigurator {
  constructor(dictionary) {
    this.dictionary = dictionary;

    // DOM ELEMENTS
    this.DOM = {
      share: document.querySelector("#share"),
      back: document.querySelector("#back"),
      zoomin: document.querySelector("#zoomin"),
      zoomout: document.querySelector("#zoomout"),
      continue: document.querySelector("#continue"),
      link: document.querySelector("#link"),
      replay: document.querySelector("#replay"),
      pause: document.querySelector("#pause"),
      play: document.querySelector("#play"),
      forward: document.querySelector("#forward"),
      skip: document.querySelector("#skip"),
      about: document.querySelector("#about"),
      volume: document.querySelector("#volume"),
      hint: document.querySelector("#hint"),
      keyboardMessage: document.querySelector("#keyboardMessage"),
      keywordResult: document.querySelector("#keywordResult"),
      learnMoreButton: document.querySelector("#learnMoreButton"),
      area: document.querySelector(".area"),
      nextButton: document.querySelector("#nextButton"),
      wrapper: document.querySelector("#aboutPage .wrapper"),
    };

    // translate dom elements
    this.DOM.share.setAttribute("data-tooltip", this.dictionary.UI_Share);
    this.DOM.back.setAttribute("data-tooltip", this.dictionary.UI_Previous);
    this.DOM.zoomin.setAttribute("data-tooltip", this.dictionary.UI_ZoomIn);
    this.DOM.zoomout.setAttribute("data-tooltip", this.dictionary.UI_ZoomOut);
    this.DOM.continue.setAttribute("data-tooltip", this.dictionary.UI_NextWord);
    this.DOM.link.setAttribute("data-tooltip", this.dictionary.UI_learnMore);
    this.DOM.replay.setAttribute("data-tooltip", this.dictionary.UI_Replay);
    this.DOM.pause.setAttribute("data-tooltip", this.dictionary.UI_Pause);
    this.DOM.play.setAttribute("data-tooltip", this.dictionary.UI_Play);
    this.DOM.forward.setAttribute("data-tooltip", this.dictionary.UI_Next);
    this.DOM.skip.setAttribute("data-tooltip", this.dictionary.UI_Skip);
    this.DOM.about.setAttribute("data-tooltip", this.dictionary.UI_About);
    this.DOM.volume.setAttribute("data-tooltip", this.dictionary.UI_Mute);
    this.DOM.hint.textContent = "";
    //keyboard message
    this.DOM.keyboardMessage.textContent = this.dictionary.UI_Keyboard;
    const span = document.createElement("span");
    span.classList.add("material-icons");
    span.textContent = "keyboard";
    this.DOM.keyboardMessage.appendChild(span);
    // learn more button
    this.DOM.learnMoreButton.textContent = this.dictionary.UI_learnMore;
    // message
    this.DOM.area.querySelector("p").textContent = this.dictionary.UI_ready;
    const br = document.createElement("br");
    this.DOM.area.querySelector("p").appendChild(br);
    const span2 = document.createElement("span");
    span2.textContent = this.dictionary.UI_look;
    this.DOM.area.querySelector("p").appendChild(span2);
    // next button
    this.DOM.nextButton.textContent = this.dictionary.UI_NextWord;
    // about page
    this.DOM.wrapper.querySelector("h3").textContent =
      this.dictionary.About_title;

    this.DOM.wrapper.querySelectorAll("p")[0].textContent = "";
    this.DOM.wrapper
      .querySelectorAll("p")[0]
      .appendChild(
        Utils.convertKeyWordIntoTag(this.dictionary.About_p1, "XYZ Toy", "span")
      );

    this.DOM.wrapper.querySelectorAll("p")[1].textContent =
      this.dictionary.About_p2;

    this.DOM.wrapper.querySelectorAll("p")[2].textContent = "";
    this.DOM.wrapper
      .querySelectorAll("p")[2]
      .appendChild(
        Utils.convertKeyWordIntoTag(this.dictionary.About_p3, "XYZ Toy", "span")
      );

    this.DOM.wrapper.querySelectorAll("p")[3].textContent =
      this.dictionary.About_p4;
  }
}
